import React from 'react';
import axios from 'cccisd-axios';
import KioskIcon from '../../images/kiosk_icon.svg';
import TakeSurveyIcon from '../../images/take_survey_icon.svg';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;

const TakeAssessment = props => {
    const logoutAndRouteToSurvey = async (e, link) => {
        e && e.preventDefault();

        await axios.get(Boilerplate.route('api.nexus.logout'));
        window.location.href = link;
    };

    const renderDeploymentLinks = (session, pawn) => {
        if (!session.sessionDeploymentInfo) {
            // Should never happen
            return <h2>There are no available session at this time.</h2>;
        }
        const deploymentInfoForContact = Object.values(session.sessionDeploymentInfo).find(
            sdi => Number(sdi.pawnId) === pawn.pawnId
        );
        const sessionDeploymentId = deploymentInfoForContact?.deploymentId;

        return (
            <div className={style.takeAssessment}>
                <button
                    type="button"
                    className={style.assessmentButton}
                    style={{ marginRight: '0.5em' }}
                    onClick={e =>
                        logoutAndRouteToSurvey(
                            e,
                            Boilerplate.url(
                                `/sessionPlayer/${sessionDeploymentId}/${props.assessment.assignmentPlanId}/${
                                    props.session.sessionId
                                }/${session.settings.reporter}/${pawn.pawnId}/${
                                    pawn.pawnHash
                                }?s=${session.settings.options.join(',')}`
                            )
                        )
                    }
                >
                    <img src={KioskIcon} alt="Kiosk Icon" />
                    <h3>Hand device to {pawn.name ?? `this ${session.settings.reporter}`}</h3>
                    <p>
                        The system automatically signs you out. Hand your device to{' '}
                        {pawn.name ?? `the ${session.settings.reporter}`}. When{' '}
                        {pawn.name ?? `the ${session.settings.reporter}`} is done, sign in again.
                    </p>
                </button>
                <button
                    type="button"
                    className={style.assessmentButton}
                    onClick={e => {
                        window.open(
                            Boilerplate.url(
                                `/sessionPlayer/${sessionDeploymentId}/${props.assessment.assignmentPlanId}/${
                                    props.session.sessionId
                                }/${session.settings.reporter}/${pawn.pawnId}/${
                                    pawn.pawnHash
                                }?s=${session.settings.options.join(',')}`
                            ),
                            '_blank'
                        );
                        props.closeModal();
                    }}
                >
                    <img src={TakeSurveyIcon} alt="Take Survey Icon" />
                    <h3>Enter data on behalf of {pawn.name ?? `this ${session.settings.reporter}`}</h3>
                    <p>
                        As {pawn.name ?? `this ${session.settings.reporter}`} takes the assessment, enter their
                        responses for them.
                    </p>
                </button>
            </div>
        );
    };

    return <div>{renderDeploymentLinks(props.session, props.pawn)}</div>;
};

export default TakeAssessment;
